import React, { useState, useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

export default function TabNavigation({ value, onChange, tabs }) {
    return (
        <>
            <Tabs
                value={value}
                onChange={onChange}
                TabIndicatorProps={{ style: { display: 'none' } }}
                sx={{
                    overflow: 'visible',
                    backgroundColor: 'none',
                    padding: '4px',
                    border: 'none',
                    borderBottom: 'solid lightgray',
                    borderWidth: '1px',
                    minHeight: 'auto',
                    display: 'inline-flex',
                    width: '100%',
                    // Target all child tabs globally
                    '& .MuiTab-root': {
                        textTransform: 'none',
                        minHeight: '36px',
                        borderRadius: '6px',
                        fontSize: '14px',
                        fontWeight: 500,
                        color: '#667085',
                        padding: '8px 16px',
                        '&:hover': {
                            color: '#102A43',
                        },
                    },
                    // Style for the selected tab
                    '& .Mui-selected': {
                        color: '#102A43 !important',
                        backgroundColor: '#ffffff',
                        border: 'solid 1px #102A43',
                        boxShadow: '0px 1px 3px rgba(16, 24, 40, 0.1)',
                    }
                }}
            >
                {tabs.map((tab) => (
                    <Tab
                        key={tab.value}
                        label={tab.label}
                        value={tab.value}
                        disabled={tab.disabled}
                    />
                ))}
            </Tabs>
            {/* {tabPage(value)} */}
        </>
    );
};

